import { Deg2Rad } from "../../../math/MathEx.js";
import { IAURotationModel } from "./IAURotationModel.js";
/*! IAU rotation model for the Moon.
 *  From the IAU/IAG Working Group on Cartographic Coordinates and Rotational Elements:
 *  http://astrogeology.usgs.gov/Projects/WGCCRE/constants/iau2000_table2.html
 */
export class IAULunarRotationModel extends IAURotationModel {
    constructor() {
        super(360.0 / 13.17635815);
    }
    calcArgs(d, E) {
        E[1] = Deg2Rad * (125.045 - 0.0529921 * d);
        E[2] = Deg2Rad * (250.089 - 0.1059842 * d);
        E[3] = Deg2Rad * (260.008 + 13.012009 * d);
        E[4] = Deg2Rad * (176.625 + 13.3407154 * d);
        E[5] = Deg2Rad * (357.529 + 0.9856993 * d);
        E[6] = Deg2Rad * (311.589 + 26.4057084 * d);
        E[7] = Deg2Rad * (134.963 + 13.064993 * d);
        E[8] = Deg2Rad * (276.617 + 0.3287146 * d);
        E[9] = Deg2Rad * (34.226 + 1.7484877 * d);
        E[10] = Deg2Rad * (15.134 - 0.1589763 * d);
        E[11] = Deg2Rad * (119.743 + 0.0036096 * d);
        E[12] = Deg2Rad * (239.961 + 0.1643573 * d);
        E[13] = Deg2Rad * (25.053 + 12.9590088 * d);
    }
    E = [];
    Pole(d, coords) {
        let T = d / 36525.0;
        T = IAURotationModel.ClampCenturies(T);
        this.calcArgs(d, this.E);
        coords.ra =
            269.9949 +
                0.0013 * T -
                3.8787 * Math.sin(this.E[1]) -
                0.1204 * Math.sin(this.E[2]) +
                0.07 * Math.sin(this.E[3]) -
                0.0172 * Math.sin(this.E[4]) +
                0.0072 * Math.sin(this.E[6]) -
                0.0052 * Math.sin(this.E[10]) +
                0.0043 * Math.sin(this.E[13]);
        coords.dec =
            66.5392 +
                0.013 * T +
                1.5419 * Math.cos(this.E[1]) +
                0.0239 * Math.cos(this.E[2]) -
                0.0278 * Math.cos(this.E[3]) +
                0.0068 * Math.cos(this.E[4]) -
                0.0029 * Math.cos(this.E[6]) +
                0.0009 * Math.cos(this.E[7]) +
                0.0008 * Math.cos(this.E[10]) -
                0.0009 * Math.cos(this.E[13]);
    }
    Meridian(d) {
        this.calcArgs(d, this.E);
        // d^2 represents slowing of lunar rotation as the Moon recedes
        // from the Earth. This may need to be clamped at some very large
        // time range (1 Gy?)
        return (38.3213 +
            13.17635815 * d -
            1.4e-12 * d * d +
            3.561 * Math.sin(this.E[1]) +
            0.1208 * Math.sin(this.E[2]) -
            0.0642 * Math.sin(this.E[3]) +
            0.0158 * Math.sin(this.E[4]) +
            0.0252 * Math.sin(this.E[5]) -
            0.0066 * Math.sin(this.E[6]) -
            0.0047 * Math.sin(this.E[7]) -
            0.0046 * Math.sin(this.E[8]) +
            0.0028 * Math.sin(this.E[9]) +
            0.0052 * Math.sin(this.E[10]) +
            0.004 * Math.sin(this.E[11]) +
            0.0019 * Math.sin(this.E[12]) -
            0.0044 * Math.sin(this.E[13]));
    }
}
